import React from 'react';

const Encouragement = props => (
  <p>
    So far, you've reviewed <strong>{props.count}</strong> talks this session. {props.count === 0
      ? <span>Get in there and start reviewing!</span>
      : props.count === 1
      ? <span>Nice! One down.</span>
      : props.count === 5
      ? <span>You're on a roll!</span>
      : props.count === 10
      ? <span>You're in the double digits!</span>
      : props.count === 19
      ? <span>Make sure to rest sometimes...</span>
      : props.count === 20
      ? <span>Nah, you're right, let's keep going.</span>
      : props.count === 49
      ? <span>Well that was impressive...someone definitely wants to be on that final committee...</span>
      : props.count === 50
      ? <span>Yep, this app wasn't tired either. Let's gooo!</span>
      : <span></span>}
  </p>
);

export default Encouragement;



// WEBPACK FOOTER //
// ./src/components/Encouragement.jsx